import { CheckboxValueType } from 'antd/lib/checkbox/Group';

import { API2_HOST } from '@/utils/constants';
import {
  NOTICE_MODULE_STATUS,
  TG_BIND_STATUS,
} from '@/utils/constants/setting';

import fetchData from './http';
import request from './request';
import { IBaseResponse, IResult } from './types/common';
import {
  ICurrentItem,
  IDepositList,
  IEmailSubscriptions,
  IMailSubcriptionPayload,
  IMailSubscriptionResult,
  INoticeItem,
  IP2PNoticeSetParams,
  IPrefSettingPayload,
  ISetTimeZoneParams,
  ISetTimeZoneRes,
  ISetUpResult,
  ITgBindParams,
  ITgNoticeList,
  IV3MemberPreferenceResult,
} from './types/settings';

const currencies = () => {
  const url = `${API2_HOST}/api/currencies`;

  return new Promise((resolve, reject) => {
    request
      .get<IBaseResponse<ICurrentItem[]>>(url, {
        useCache: true,
        ttl: 5 * 60 * 1000,
      })
      .then((response) => {
        resolve(response.result || []);
      })
      .catch((error) => {
        reject(error?.response ? error?.response.data : error);
      });
  });
};

// 获取通知列表
const getNoticeList = () => {
  // const url = `${API2_HOST}/v2/private/message/module/list`;
  const url = `${API2_HOST}/v2/private/message/module/list`;
  return new Promise((resolve, reject) => {
    fetchData
      .get<IBaseResponse<INoticeItem[]>>(url)
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

const getV3MemberPreference = (params: { config_keys: string[] }) => {
  const url = `${API2_HOST}/v3/private/user/member/preferences`;
  return new Promise((resolve, reject) => {
    request
      .post<IBaseResponse<IV3MemberPreferenceResult>>(url, {
        useCache: true,
        body: JSON.stringify(params),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

const getMailSubscription = () => {
  // const url = `${API2_HOST}/s1/mailing-subscription/get-subscription`;
  const url = `${API2_HOST}/s1/mailing-subscription/get-subscription`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IMailSubscriptionResult>>(url, {
        body: JSON.stringify({ data: null, from: null }),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

const applyMailSubcription = (param: IMailSubcriptionPayload) => {
  // const url = `${API2_HOST}/s1/mailing-subscription/subscribe`;
  const url = `${API2_HOST}/s1/mailing-subscription/subscribe`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, { body: JSON.stringify(param) })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

// 设置用户货币
const setCurrencyCode = (currency_code: string) => {
  const url = `${API2_HOST}/user/set-currency-code`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify({ currency_code }),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

// 设置通知语言
const setNotificationLang = (lang: string) => {
  const url = `${API2_HOST}/user/set-notification-lang`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, { body: JSON.stringify({ lang }) })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

// 用户设置通知开关(交易通知/活动通知/系统通知)
const switchNotifyByNotice = (id: number) => {
  const url = `${API2_HOST}/v2/private/message/unsubscribe`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify({ id }),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error?.response ? error?.response?.data : error);
      });
  });
};

// 用户设置通知开关 - 需要安全组件校验的模块 - 用户服务提供的接口，
const switchNotifyByUser = (
  id: number,
  status: NOTICE_MODULE_STATUS,
  risk_token: string,
) => {
  const url = `${API2_HOST}/user/public/secure/profiles/change`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify({
          secure_profile_post: JSON.stringify({
            [id]: `${status}`,
          }),
          page_id: '/web/user/settings/msginstation',
          risk_token,
        }),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error?.response ? error?.response?.data : error);
      });
  });
};

// 弹窗管理
const doubleConfirmSave = (confirms: CheckboxValueType[]) => {
  const url = `${API2_HOST}/user/double-confirm/save`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, { body: JSON.stringify({ confirms }) })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

// 充值设置
const setV3MemberPreference = (params: IPrefSettingPayload) => {
  const url = `${API2_HOST}/v3/private/user/member/pref-setting`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, { body: JSON.stringify(params) })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

const getDepositList = () => {
  const url = `${API2_HOST}/user/private/deposit/list`;
  return new Promise((resolve, reject) => {
    fetchData
      .get<IBaseResponse<IDepositList>>(url)
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

const setTimeZone = (params: ISetTimeZoneParams) => {
  const url = `${API2_HOST}/v3/private/user/member/pref-setting`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<ISetTimeZoneRes>>(url, {
        body: JSON.stringify(params),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

const setTelegram = (params: ITgBindParams) => {
  const url = `${API2_HOST}/user/private/telegram/set`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<ISetUpResult>>(url, {
        body: JSON.stringify(params),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

const getTelegramBindStatus = () => {
  const url = `${API2_HOST}/user/private/bind-info-up`;
  return new Promise<{ telegram_status: TG_BIND_STATUS }>((resolve, reject) => {
    request
      .get(url)
      .then((response: any) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

// const getTelegramP2PBindStatus = () => {
//   const url = `${API2_HOST}/notification-site/v1/private/telegram/list_tg_sub_stat_v1`;
//   return new Promise<ITgNoticeList>((resolve, reject) => {
//     fetchData
//       .get(url)
//       .then((response: any) => {
//         resolve(response.result);
//       })
//       .catch((error) => {
//         reject(error.response ? error.response.data : error);
//       });
//   });
// };

const getTelegramP2PBindStatus = () => {
  const url = `${API2_HOST}/fiat/otc/configuration/user/notice-config/get`;
  return new Promise<ITgNoticeList>((resolve, reject) => {
    request
      .get(url, {
        useCache: true,
      })
      .then((response: any) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

const setTelegramP2PBind = (params: IP2PNoticeSetParams) => {
  const url = `${API2_HOST}/fiat/otc/configuration/user/notice-config/switch_v2`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<ISetUpResult>>(url, {
        body: JSON.stringify(params),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

// 获取邮件订阅列表
const getEmailSubscriptionsList = () => {
  const url = `${API2_HOST}/notification-site/v2/private/get-subscription`;
  return new Promise((resolve, reject) => {
    request
      .post<IBaseResponse<IEmailSubscriptions[]>>(url)
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

// 用户设置订阅
const userSetSubscriptions = (subscribe_modules: string) => {
  const url = `${API2_HOST}/notification-site/v2/private/subscribe`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify({ subscribe_modules }),
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error?.response ? error?.response?.data : error);
      });
  });
};

export {
  applyMailSubcription,
  currencies,
  doubleConfirmSave,
  getDepositList,
  getEmailSubscriptionsList,
  getMailSubscription,
  getNoticeList,
  getTelegramBindStatus,
  getTelegramP2PBindStatus,
  getV3MemberPreference,
  setCurrencyCode,
  setNotificationLang,
  setTelegram,
  setTelegramP2PBind,
  setTimeZone,
  setV3MemberPreference,
  switchNotifyByNotice,
  switchNotifyByUser,
  userSetSubscriptions,
};
